import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DetailedSearchResultsGrid from './DetailedSearchResultsGrid';

import { DRIVER, VEHICLE } from './content';
import {
  getSeletedNum,
  getSeletedType,
  getSearchResults,
  getInputText,
  fetchSearchResults,
  onSelect
} from '../store/action';

const DetailedSearchResultContainer = (
  {
    items,
    total,
    rowCount,
    currentPage: currentpage,
    variant,
    type,
    isFetchingResult,
    searchTerm,
    getResults
  },
  context
) => {
  const redirectToDashboard = (dashboardType, id, countryCode, dashVersion) => {
    const basePath = `/dashboard/${dashboardType.toLowerCase()}/${countryCode.toLowerCase()}/${id}`;

    if (dashVersion && dashVersion == 'v2') {
      window.location.href = `/v2${basePath}`;
    } else {
      context.router.push({
        pathname: `/v1${basePath}`,
        state: { id, dashboardType }
      });
    }
  };

  const getDetailedSearchResults = (currentPage, sortQuery) => {
    const fetchParams = {
      offset: currentPage * rowCount,
      limit: rowCount,
      lookup: searchTerm,
      sort: sortQuery || '',
      lookupType: type !== DRIVER ? type : null
    };

    getResults(
      {
        fetchParams: { ...fetchParams },
        type,
        currentPage
      },
      sortQuery
    );
  };

  const onDataRowClick = data => {
    const rowObj = data.props.data;
    if (type === DRIVER) {
      redirectToDashboard(
        DRIVER,
        rowObj.DriverId,
        rowObj.CountryCode,
        rowObj.dashVersion
      );
    }
    if (type !== DRIVER) {
      redirectToDashboard(
        VEHICLE,
        rowObj.LeaseId,
        rowObj.CountryCode,
        rowObj.dashVersion
      );
    }
  };

  return (
    <DetailedSearchResultsGrid
      data={items}
      total={total}
      getExternalData={getDetailedSearchResults}
      rowCount={rowCount}
      onDataRowClick={onDataRowClick}
      currentPage={currentpage}
      dataFetching={isFetchingResult}
      variant={variant}
      type={type}
    />
  );
};

DetailedSearchResultContainer.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  type: PropTypes.string,
  currentPage: PropTypes.number
};

DetailedSearchResultContainer.defaultProps = {
  items: [],
  total: 0,
  type: 'Driver',
  currentPage: 0
};

DetailedSearchResultContainer.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => {
  const {
    isFetchingResult,
    total,
    searchResults,
    currentPage
  } = getSearchResults(state);
  const type = getSeletedType(state);

  const variant = 'iceBlue';

  return {
    rowCount: Number(getSeletedNum(state)),
    type,
    variant,
    isFetchingResult,
    total,
    items: searchResults,
    currentPage,
    searchTerm: getInputText(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getResults: bindActionCreators(fetchSearchResults, dispatch),
  select: bindActionCreators(onSelect, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailedSearchResultContainer);



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/DetailedSearchResultContainer.js